// extracted by mini-css-extract-plugin
export default {"files_rows":"index_files_rows__h82zu","group_header":"index_group_header__tLe9-","flies_group":"index_flies_group__VLI+f"};